<template>
  <div>
    <div class="mt-1">
      <label>Выбрать производителя</label>
      <div class="flex">
        <div class="flex-grow-1">
          <Search
            ref="searchM"
            :customPreset="{placeholder:'Поиск производителя'}"
            searchType="manufacturer"
            :onSelect="(m) => addNewManufacturer(m)"
          />
        </div>
        <button @click="addNewManufacturer()" type="button" class="btn btn-default">Создать нового</button>
      </div>
      <div v-if="selectedManufacturer?.id || createNewManufacturer">
        <EditManufacturer
          :onSelectManufacturer="(m) => addNewManufacturer(m)"
          :savedManufacturer="selectedManufacturer"
        />
      </div>
    </div>
    <hr>
    <div class="form-group">
      <label for="">Выберите препарат</label>
      <Search
        ref="search"
        :customPreset="{placeholder:'Поиск препарата'}"
        searchType="003_drugs"
        :onSelect="(record) => addDrug(record)"
      />
    </div>
    <div>
      <div class="form-group">
        <div class="flex justify-content-between mb-1"><span>Комментарии</span>
          <button @click="addComment" class="btn btn-default">добавить комментарий</button>
        </div>
        <div class="input-group" v-for="(c, i) in reportComments">
          <textarea v-model="c.text" type="text" class="form-control"/>
          <div class="input-group-append">
            <DateSelectProps
              :disabled="true"
              :onSelect="(date) => c.date = date"
            />
          </div>
        </div>
      </div>
    </div>
    <div class="mt-2 text-right">
      <LoadingButton
        title="Сохранить"
        :loading="loading"
        :color="$constants.SUCCESS_COLOR"
        :onClick="() => saveTask()"
        className="btn btn-outline-success"
      />
    </div>
  </div>
</template>

<script>
import Search from "@/components/search/Search.vue";
import EditManufacturer from "@/components/manufacturer/EditManufacturer.vue";
import DateSelectProps from "@/views/reports/components/DateSelectProps.vue";
import LoadingButton from "@/components/buttons/LoadingButton.vue";
import api from "@/api";

export default {
  components: {
    LoadingButton,
    DateSelectProps,
    EditManufacturer,
    Search,
  },
  data() {
    return {
      loading: false,
      selectedDrug: null,
      reportComments: [{date: null, text: null}],
      createNewManufacturer: false,
      selectedManufacturer: null,
    }
  },
  methods: {
    resetTask() {
      this.reportComments = [{date: null, text: null}];
      this.selectedDrug = null;
      this.selectedManufacturer = null;
    },
    async addNewManufacturer(manufacturer = {}) {
      this.createNewManufacturer = false;
      this.selectedManufacturer = null;
      this.$refs.searchM.selected = null;
      await this.$nextTick();
      this.selectedManufacturer = manufacturer;
      if (!manufacturer?.id) this.createNewManufacturer = true;
    },
    addComment() {
      this.reportComments.push({date: null, text: null});
    },
    async saveTask() {
      if (!this.selectedManufacturer?.id) {
        toastr['warning']('Выберите производителя', 'Ошибка');
        return;
      }
      if (!this.selectedDrug?.id) {
        toastr['warning']('Выберите препарат', 'Ошибка');
        return;
      }
      let commentCheckPass = true;
      if (this.reportComments.find((c) => !c.text)) {
        console.log('no text');
        commentCheckPass = false;
      }
      if (this.reportComments.find((c) => c.text && !c.date)) {
        console.log('no date', this.reportComments.find((c) => c.text && !c.date));
        commentCheckPass = false;
      }
      if (!commentCheckPass) {
        toastr['warning']('Выберите дату для комментариев', 'Ошибка');
        return;
      }
      this.loading = true;
      // console.log(this.selectedManufacturer, this.selectedDrug);
      const {data} = await api.post('/tasks/history', {
        object_id: this.selectedDrug.id,
        manufacturer_id: this.selectedManufacturer.id,
        comments: this.reportComments,
      })
      if (data.success) {
        this.resetTask();
        toastr['success'](data.message ?? 'Сохранено', 'Успешно');
      } else {
        toastr['warning'](data.message ?? 'Ошибка сервера', 'Неуспешно');
      }
      this.loading = false;
    },
    addDrug(d) {
      this.selectedDrug = d;
    }
  }
}
</script>
